export default "__VITE_ASSET__7PX8se7O__"